// 🔗 평문 속 생 URL 분할 — 순수 규칙 (2026-09-16 사용자 "공지사항 바로가기 http → link 로 웹페이지 열기").
//   공지(팝업·알림창·배너)의 평문 분기는 본문을 텍스트 노드로만 그려서, 그룹웨어 공지처럼
//   "PC 그룹웨어 바로가기: http://play.powerlogics.kr/" 로 배달된 주소가 죽은 글자였다.
//   렌더(JSX)는 linkify.tsx 가 맡고, 여기는 "어디까지가 URL 인가" 만 정한다(테스트 대상).

export type LinkSeg =
	| { kind: 'text'; text: string }
	| { kind: 'url'; url: string; tail: string };

// http/https 만. 공백·꺾쇠·따옴표에서 끊는다(HTML 분기는 sanitizeNoticeHtml 가 따로 처리).
const PLAIN_URL_RE = /https?:\/\/[^\s<>"']+/g;
// 문장 끝 부호는 주소가 아니다 — "…열기: http://a.b/c." 의 마침표, 괄호로 감싼 (http://a.b) 의 닫는 괄호.
const TRAIL_RE = /[.,;:!?)\]]+$/;

/** 평문을 텍스트/URL 조각으로 나눈다. 원문 글자는 하나도 잃거나 더하지 않는다(조각을 이으면 원문). */
export function splitPlainUrls(text: string): LinkSeg[] {
	const out: LinkSeg[] = [];
	let last = 0;
	for (const m of text.matchAll(PLAIN_URL_RE)) {
		const raw = m[0];
		const at = m.index ?? 0;
		const url = raw.replace(TRAIL_RE, '');
		if (!url) continue;                       // 부호만 남는 경우는 없지만 방어
		if (at > last) out.push({ kind: 'text', text: text.slice(last, at) });
		out.push({ kind: 'url', url, tail: raw.slice(url.length) });
		last = at + raw.length;
	}
	if (last < text.length) out.push({ kind: 'text', text: text.slice(last) });
	return out;
}

/** 스킴이 빠진 주소(play.powerlogics.kr/x)인가 — 호스트처럼 생겼고 앱 내부 경로가 아니다. */
export function looksBareHost(s: string): boolean {
	if (!s || /^[a-z][a-z0-9+.-]*:/i.test(s)) return false;        // 이미 스킴이 있다
	if (s.startsWith('/') || s.startsWith('#') || s.startsWith('?')) return false;  // 앱 내부 경로
	return /^[\w-]+(\.[\w-]+)+(:\d+)?([/?#].*)?$/.test(s);
}
